import { useTranslations } from 'next-intl';
import CurrencyIcon from '../icons/currency-icon';
import ProductLabel from './product-card-label';
import { handlePriceByComma } from '@/helpers/common';
import FlashSaleCountdown from '../badges/flash-sale-countdown';
import { isFlashSaleActive } from '@/utils/product';

const ProductLabels = ({
  label,
  prices,
  requirePrescription,
  showOfferLabel = true,
  flashSaleStartDate,
  flashSaleEndDate,
}) => {
  const t = useTranslations('product');
  const hasActiveFlashSale = isFlashSaleActive(
    flashSaleStartDate,
    flashSaleEndDate
  );

  return (
    <>
      <div className='absolute bottom-0 flex flex-wrap items-center gap-2'>
        {label
          ?.filter(
            (el) => el && el?.is_active === '1'
            //  &&
            // new Date(el?.active_from) < new Date() < new Date(el?.active_to)
          )
          ?.map((label, i) => (
            <ProductLabel label={label} key={i} />
          ))}
      </div>

      <FlashSaleCountdown
        startDate={flashSaleStartDate}
        endDate={flashSaleEndDate}
      />

      {!!prices?.specialPrice && showOfferLabel && !hasActiveFlashSale && (
        <div
          className={`absolute start-0 top-2 z-24 flex w-fit items-center gap-0.5 rounded-xl bg-[#ffe8e8] px-2.25 py-0.75 text-center text-sm font-bold text-[#c62828] max-sm:top-0`}
        >
          <span>{t('Save_key')}</span>
          {handlePriceByComma(prices.originalPrice - prices.specialPrice)}{' '}
          <CurrencyIcon className='size-2.75' />
        </div>
      )}

      {requirePrescription && (
        <div
          className={`absolute right-0 bottom-0 z-24 flex w-fit items-center gap-0.5 rounded-xl bg-[#FFFAD3] px-2.25 py-0.75 text-center text-sm font-bold text-[#89701A]`}
        >
          {t('prescriptionRequired')}
        </div>
      )}
    </>
  );
};

export default ProductLabels;
